import { useState } from 'react';
import {
    IconButton,
    Tooltip,
    Menu,
    MenuItem,
    ListItemIcon,
    ListItemText,
    CircularProgress,
} from '@mui/material';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import GridOnIcon from '@mui/icons-material/GridOn';

const ExportButton = ({
    onExport,
    tooltip = 'Export',
    disabled = false,
    options = ['excel', 'pdf'],
    isExporting = false,
}) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const handleOpen = (event) => {
        if (!disabled) {
            setAnchorEl(event.currentTarget);
        }
    };

    const handleClose = () => setAnchorEl(null);

    const handleSelect = (type) => {
        if (!onExport) return;
        handleClose();
        onExport(type);
    };

    return (
        <>
            <Tooltip title={tooltip} arrow>
                <span>
                    <IconButton
                        size="small"
                        disabled={disabled || isExporting}
                        onClick={handleOpen}
                        sx={{ width: 40, height: 40, border: '1px solid', borderColor: 'divider' }}
                    >
                        {isExporting ? <CircularProgress size={18} color="inherit" /> : <FileDownloadIcon />}
                    </IconButton>
                </span>
            </Tooltip>

            <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
            >
                {options.includes('excel') && (
                    <MenuItem onClick={() => handleSelect('excel')}>
                        <ListItemIcon>
                            <GridOnIcon fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>Export as Excel</ListItemText>
                    </MenuItem>
                )}

                {options.includes('pdf') && (
                    <MenuItem onClick={() => handleSelect('pdf')}>
                        <ListItemIcon>
                            <PictureAsPdfIcon fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>Export as PDF</ListItemText>
                    </MenuItem>
                )}
            </Menu>
        </>
    );
};

export default ExportButton;
